import { inr, fmtDate } from "../../lib/api";
import { GlassCard, Badge, Empty } from "../kit";

export function StudentFeeSummary({ summary, compact = false, testid = "student-fee-summary" }) {
  if (!summary?.invoices.length) return compact ? <p className="text-sm text-zinc-500">No fees yet.</p> : <GlassCard className="p-6"><Empty hint="No fees for this student yet." /></GlassCard>;
  const { total, by_type, invoices } = summary;
  const body = (
    <>
      <div className="grid grid-cols-3 gap-3">
        {[["Total", total.billed, "text-white"], ["Paid", total.paid, "text-emerald-300"], ["Outstanding", total.balance, "text-orange-300"]].map(([k, v, c]) => (
          <div key={k} className="rounded-2xl bg-white/5 p-3"><div className="eyebrow !text-[10px]">{k}</div><div className={`mt-1 font-display text-lg ${c}`} data-testid={`${testid}-${k.toLowerCase()}`}>{inr(v)}</div></div>
        ))}
      </div>
      <div className="mt-4 space-y-1.5">
        {by_type.map((b) => (
          <div key={b.fee_type} className="flex items-center justify-between rounded-xl bg-white/[0.03] px-3 py-2 text-sm" data-testid={`${testid}-type-${b.fee_type}`}>
            <span className="text-zinc-200">{b.fee_type} <span className="text-xs text-zinc-500">· {b.items} item{b.items === 1 ? "" : "s"}</span></span>
            <span className="text-xs"><span className="text-zinc-400">{inr(b.paid)} / {inr(b.billed)}</span>{b.balance > 0 && <span className="ml-2 text-orange-300">{inr(b.balance)} due</span>}</span>
          </div>
        ))}
      </div>
      {!compact && (
        <div className="mt-5 max-h-80 overflow-y-auto">
          <table className="w-full text-sm [&_td]:px-2 [&_td]:py-1.5 [&_th]:px-2 [&_th]:pb-2 [&_th]:text-left [&_th]:text-[11px] [&_th]:uppercase [&_th]:text-zinc-500">
            <thead><tr><th>Fee</th><th>Session</th><th>Amount</th><th>Paid</th><th>Due</th><th>Status</th></tr></thead>
            <tbody>{invoices.map((i) => (
              <tr key={i.id}><td className="text-zinc-200">{i.title}{i.remarks ? <span className="block text-[11px] text-zinc-500">{i.remarks}</span> : null}</td><td className="text-zinc-400">{i.academic_year}</td>
                <td>{inr(i.amount)}</td><td className="text-emerald-300">{inr(i.paid_amount)}</td><td className="text-zinc-400">{fmtDate(i.due_date)}</td><td><Badge status={i.status}>{i.status}</Badge></td></tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </>
  );
  return compact ? <div data-testid={testid}>{body}</div> : <GlassCard className="p-4 sm:p-6" data-testid={testid}><h3 className="mb-4 font-display text-lg text-white">All fees of this student</h3>{body}</GlassCard>;
}
